module.exports = __webpack_public_path__ + "static/media/2.bcf262f7.jpg";